export const USER_PREFERENCE_KEYS = {
  PROJECT_LIST_COLUMN_ORDER: 'project_list.column_order',
  PROJECT_LIST_VISIBLE_COLUMNS: 'project_list.visible_columns',
  PROJECT_LIST_PINNED_COLUMNS: 'project_list.pinned_columns',
  CONTACTS_COLUMN_ORDER: 'contacts.column_order',
  CONTACTS_VISIBLE_COLUMNS: 'contacts.visible_columns',
  CONTACTS_PINNED_COLUMNS: 'contacts.pinned_columns',
  INVENTORY_COLUMN_ORDER: 'inventory.column_order',
  INVENTORY_VISIBLE_COLUMNS: 'inventory.visible_columns',
  INVENTORY_PINNED_COLUMNS: 'inventory.pinned_columns',
  EQUIPMENT_COLUMN_ORDER: 'equipment.column_order',
  EQUIPMENT_VISIBLE_COLUMNS: 'equipment.visible_columns',
  EQUIPMENT_PINNED_COLUMNS: 'equipment.pinned_columns',
  ARCHIVE_COLUMN_ORDER: 'archive.column_order',
  ARCHIVE_VISIBLE_COLUMNS: 'archive.visible_columns',
  ARCHIVE_PINNED_COLUMNS: 'archive.pinned_columns',
  ACCOUNTS_COLUMN_ORDER: 'accounts.column_order',
  ACCOUNTS_VISIBLE_COLUMNS: 'accounts.visible_columns',
  ACCOUNTS_PINNED_COLUMNS: 'accounts.pinned_columns',
};
